import { createContext, useContext } from 'react';

/**
 * ストーリーボードの右カラム(シーン一覧)がコンパクト表示かどうか。
 * メイン領域が狭く左列(ストーリーボード設定+候補)が畳まれているのと同じタイミングで
 * true になり、シーン見出しを「シーン1」→「1」のように簡略化する。
 *
 * StoryboardCandidates が children をこの Provider で包んで配下の SceneItem に伝える。
 * 非ストーリーボードモードでは Provider が無いので既定値 false (通常表記) のまま。
 */
export const StoryboardCompactContext = createContext(false);

export const useStoryboardCompact = (): boolean => useContext(StoryboardCompactContext);
